"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Organization = void 0;
const menu_option_1 = require("./menu-option");
const app_module_1 = require("./app.module");
const token_service_1 = require("./token.service");
const baseURL = '/organization';
class Organization {
    constructor(params = {}) {
        Object.assign(this, params);
        this.text = this.displayName;
    }
    static list(params = {}) {
        let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
        return new Promise((resolve, reject) => {
            http.get(`${baseURL}/list?${$.param(params)}`)
                .toPromise()
                .then(response => response.json())
                .then(response => {
                let organizations = response.map(organization => new Organization(organization));
                resolve(organizations);
            })
                .catch(err => {
                reject(err);
            });
        });
    }
    static serializeCollection(organizations) {
        return organizations.map(params => { return new Organization(params); });
    }
    static toMenuOptions(organizations) {
        return organizations.map(organization => {
            if (organization.hasClients()) {
                return organization.toMenuOption();
            }
        }).filter(Boolean);
    }
    getClientIds() {
        return this.clients.map(client => {
            return String(client.id);
        });
    }
    hasClients() {
        return this.clients && this.clients.length > 0;
    }
    toMenuOption() {
        return new menu_option_1.MenuOption({
            displayName: this.displayName,
            codes: this.getClientIds(),
            selected: false,
            count: 0,
            enabled: true
        });
    }
    isTypeClient() {
        return this.type === 'client-side---publisher';
    }
}
exports.Organization = Organization;
//# sourceMappingURL=organization.js.map